import Vue from 'vue'
import { i18n } from './../api/i18n'
var v = new Vue()
export default function $alert(content, action, title, buttonText) {
    title = title || 'hint';
    buttonText = buttonText || 'enSure';
    v.$alert(i18n.t(content), i18n.t(title), {
        confirmButtonText: i18n.t(buttonText),
        callback: s=> {
            if(action && typeof action == 'function'){
                action();
            }
        }
    });
    return true;
}

